import { createPortal } from 'react-dom';
import { X, History, FileSpreadsheet, MapPin } from 'lucide-react';
import { eur } from '../lib/license';
import { countEntries, countTotals, exportCountsXLSX } from '../lib/inventory';

export default function CountHistory({ t, lang, project, onClose, onOpenReport }) {
  const entries = countEntries(project.reports);
  const { rows, total, pieces } = countTotals(entries);
  const money = (v) => (v == null ? '–' : eur(v, t.locale));

  return createPortal(
    <div className="editor-backdrop" data-testid="count-history-dialog" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="editor hist">
        <div className="editor-head">
          <h4><History size={18} /> {t.histTitle}</h4>
          <button className="icon-btn" data-testid="count-history-close-btn" onClick={onClose}><X size={16} /></button>
        </div>
        {!entries.length ? <p className="muted" data-testid="count-history-empty">{t.histEmpty}</p> : (
          <>
            <div className="hist-kpis">
              <span data-testid="count-history-count"><b>{entries.length}</b> {t.histCounts}</span>
              <span data-testid="count-history-pieces"><b>{pieces}</b> {t.histPieces}</span>
              <span data-testid="count-history-total"><b>{eur(total, t.locale)}</b> {t.invSum}</span>
            </div>
            <button className="btn btn-green" data-testid="count-history-xlsx-btn" onClick={() => exportCountsXLSX(project, lang)}><FileSpreadsheet size={16} /> {t.histXlsx}</button>
            <div className="hist-list">
              {entries.map((e, i) => (
                <div className="hist-item" key={e.id} data-testid={`count-history-item-${i}`}>
                  <img src={e.thumb} alt="" />
                  <div>
                    <button className="hist-rep" data-testid={`count-history-open-${i}`} onClick={() => onOpenReport(e.rid)}><MapPin size={12} /> {e.report}</button>
                    <small>{new Date(e.date).toLocaleString(t.locale)}</small>
                    <ul>{e.items.map((it) => <li key={it.type}><span>{it.n}× {it.type}</span><span>{it.price != null ? `à ${money(it.price)}` : ''}</span><b>{money(it.amount)}</b></li>)}</ul>
                    {e.total > 0 && <p className="hist-sub">{t.invSum}: <b>{eur(e.total, t.locale)}</b></p>}
                  </div>
                </div>
              ))}
            </div>
            <div className="hist-sum" data-testid="count-history-summary">
              <b>{t.histTotals}</b>
              {rows.map((r) => <div key={r.type}><span>{r.type}</span><span>{r.n}</span><b>{r.priced ? money(r.amount) : '–'}</b></div>)}
              <div className="hist-grand"><span>{t.invSum}</span><span>{pieces}</span><b>{eur(total, t.locale)}</b></div>
            </div>
          </>
        )}
      </div>
    </div>,
    document.body,
  );
}
